// Ukrainian
export const uk = {
  'app.name':           'Kardolive',
  'app.tagline':        'Портал клієнта',
  'app.signOut':        'Вийти',

  'login.email':        'Електронна пошта',
  'login.password':     'Пароль',
  'login.signIn':       'Увійти',
  'login.signingIn':    'Виконується вхід…',
  'login.failed':       'Помилка входу',
  'login.newAccount':   'Уперше на Kardolive?',
  'login.createAccount':'Створити безкоштовний акаунт →',

  'nav.workspace':      'Робоча область',
  'nav.templates':      'Шаблони',
  'nav.live':           'Трансляції',
  'nav.rooms':          'Кімнати та чат',
  'nav.content':        'Контент',
  'nav.developer':      'Розробник',
  'nav.account':        'Обліковий запис',

  'nav.overview':       'Огляд',
  'nav.projects':       'Проєкти',
  'nav.chat':           'Консоль чату',
  'nav.sessions':       'Сесії',
  'nav.streams':        'Прямі трансляції',
  'nav.studio':         'Студія',
  'nav.recordings':     'Записи',
  'nav.apiKeys':        'API-ключі',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Тестер вебхуків',
  'nav.networkTest':    'Тест мережі',
  'nav.embed':          'Вбудовані віджети',
  'nav.sdk':            'SDK та документація',
  'nav.docs':           'Документація',
  'nav.analytics':      'Аналітика',
  'nav.settings':       'Налаштування',

  'overview.welcome':       'З поверненням, {name}',
  'overview.plan':          '{tenant} · план {plan}',
  'overview.newStream':     'Нова трансляція',
  'overview.kpi.live':           'Зараз в ефірі',
  'overview.kpi.live.broadcasting': 'трансляцій триває',
  'overview.kpi.live.nothing':    'нічого в ефірі',
  'overview.kpi.total':           'Усього трансляцій',
  'overview.kpi.total.sub':       'за весь час',
  'overview.kpi.sessions':        'Сеанси · 30 днів',
  'overview.kpi.sessions.sub':    'події публікації',
  'overview.kpi.recordings':      'Записи',
  'overview.kpi.recordings.sub':  'готові до відтворення',
  'overview.recentStreams':       'Останні трансляції',
  'overview.recentSessions':      'Останні сеанси',
  'overview.viewAll':             'Переглянути всі →',
  'overview.empty.title':         'Поки немає трансляцій',
  'overview.empty.body':          'Створіть свою першу трансляцію, щоб почати мовлення.',
  'overview.empty.action':        'Створити трансляцію',
  'overview.noSessions':          'Поки немає сеансів',

  'status.live':        'В ЕФІРІ',
  'status.idle':        'ОЧІКУВАННЯ',
  'status.ended':       'ЗАВЕРШЕНО',
  'status.archived':    'У АРХІВІ',

  'common.save':        'Зберегти',
  'common.cancel':      'Скасувати',
  'common.delete':      'Видалити',
  'common.edit':        'Редагувати',
  'common.create':      'Створити',
  'common.confirm':     'Підтвердити',
  'common.loading':     'Завантаження…',
  'common.error':       'Помилка',
  'common.retry':       'Повторити',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Перейти до вмісту сторінки",
  "nav.streamTemplates": "Шаблони трансляцій",
  "nav.boards": "Інтерактивні дошки",
  "nav.menu": "Відкрити навігацію",
  "nav.closeMenu": "Закрити навігацію",
  "nav.scenarios": "Сценарії",
  "nav.premieres": "Прем’єри",
  "nav.clips": "Кліпи",
  "dashboard.account": "Обліковий запис",
  "dashboard.language": "Мова",
  "dashboard.appearance": "Вигляд",
  "nav.allStreams": "Усі трансляції",
  "nav.destinations": "Напрямки ретрансляції",
  "nav.ecommerce": "Електронна торгівля",
  "nav.products": "Товари",
  "nav.services": "Послуги",
  "nav.collections": "Колекції",
  "nav.orders": "Замовлення",
  "nav.commerceSettings": "Налаштування торгівлі",
  "nav.engagement": "Взаємодія",
  "theme.light": "Перейти до світлої теми",
  "theme.dark": "Перейти до темної теми",
  "role.owner": "Власник",
  "role.admin": "Адміністратор",
  "role.member": "Учасник",
  "role.viewer": "Спостерігач",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Активні",
  "streams.archived": "В архіві",
  "streams.monitor": "Монітор джерел",
  "streams.create": "Створити пряму трансляцію",
  "streams.list": "Список",
  "streams.grid": "Сітка",
  "streams.view": "Вигляд списку трансляцій",
  "streams.searchLabel": "Пошук подій",
  "streams.searchHint": "Пошук за назвою",
  "streams.solutionFilter": "Фільтр за типом події",
  "streams.statusFilter": "Фільтр за статусом",
  "streams.dateFilter": "Фільтр за датою створення",
  "streams.allSolutions": "Усі типи",
  "streams.custom": "Наявне або власне налаштування",
  "streams.allStatuses": "Усі статуси",
  "streams.anyTime": "Будь-яка дата створення",
  "streams.last7": "Створені за останні 7 днів",
  "streams.last30": "Створені за останні 30 днів",
  "streams.count": "Показано подій: {shown} із {total}",
  "streams.noMatch": "Немає подій, що відповідають фільтрам.",
  "streams.clearFilters": "Скинути фільтри",
  "streams.refreshFailed": "Не вдалося оновити список",
  "streams.loadFailed": "Не вдалося завантажити трансляції",
  "streams.stale": "Показано останній завантажений список. Статуси могли змінитися.",
  "streams.connectionHint": "Перевірте з’єднання та завантажте список знову.",
  "streams.retrying": "Повторна спроба…",
  "streams.retry": "Спробувати знову",
  "streams.restoreFailed": "Не вдалося відновити трансляцію",
  "streams.restoreHint": "Перевірте з’єднання та оновіть список, щоб уточнити статус перед повторною спробою.",
  "streams.unused": "Невикористані трансляції: {count}",
  "streams.unusedHint": "Немає ефірів чи повторів. Архівуйте їх, щоб упорядкувати список; нічого не буде видалено.",
  "streams.reviewArchive": "Переглянути й архівувати",
  "streams.loading": "Завантаження трансляцій…",
  "streams.archiveEmpty": "Архів порожній. Архівні трансляції та їхні повтори залишаються тут до відновлення.",
  "streams.restore": "Відновити",
  "streams.firstTitle": "Створіть першу трансляцію",
  "streams.firstBody": "Виберіть налаштування для продажів, занять чи послуг або почніть із порожньої трансляції. Виходьте в ефір із браузера, телефона чи OBS.",
  "streams.blank": "Порожня трансляція",
  "streams.broadcasts": "Ефіри: {count}",
  "streams.replays": "Повтори: {count}",
  "streams.sessions": "Сесії: {count}",
  "streams.recordings": "Записи: {count}",
  "streams.mode.BROADCAST": "Мовлення",
  "streams.mode.LOW_LATENCY": "Низька затримка",
  "streams.mode.REALTIME": "У реальному часі",
  "streams.key": "Ключ",
  "streams.archiveTitle": "Архівувати невикористані трансляції",
  "streams.archiveHint": "Ці трансляції ще не виходили в ефір. Їх можна будь-коли відновити на вкладці «В архіві».",
  "streams.archiveFailed": "Не вдалося архівувати {count} трансляцій: можливо, вони вже вийшли в ефір. Решту архівовано.",
  "streams.archiving": "Архівування…",
  "streams.archiveCount": "Архівувати: {count}",
  "streamType.webinar": "Бізнес-вебінари та презентації",
  "streamType.classroom": "Уроки й репетиторство",
  "streamType.training": "Корпоративне навчання",
  "streamType.conference": "Конференції та виставки",
  "streamType.shopping": "Покупки наживо",
  "streamType.auction": "Аукціони наживо",
  "streamType.consultation": "Приватні консультації",
  "streamType.creator": "Ефіри авторів і спільнот",
  "streamType.audio": "Аудіокімнати й подкасти",
  "streamType.sports": "Спорт і кіберспорт",
  "streamType.performance": "Концерти й виступи",
  "streamType.community": "Богослужіння та збір коштів",
  "streamType.tour": "Екскурсії та демонстрації",
  "streamType.fitness": "Фітнес і майстер-класи",
  "streamType.public-meeting": "Новини та публічні зібрання",
  "streamType.continuous": "Безперервні канали й камери",
  "streams.close": "Закрити",
};
